import {
  mapCartLine,
  mapCartLines,
  mapTransactionProducts,
} from '@shared/analytics/mapper'
import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onDecreaseCartLineEvent,
  onIncreaseCartLineEvent,
  onViewCartEvent,
  removeDecreaseCartLineEvent,
  removeIncreaseCartLineEvent,
  removeViewCartEvent,
} from '@shared/event/events/cart'

export const initCartEvents = (Analytics: GooglePlugin) => {
  const increaseCartItemToken = onIncreaseCartLineEvent(
    ({ cartLine, quantity, cart }) => {
      Analytics.event({
        ecommerce_ga4: null,
      })
      const ATCEvent = {
        event: 'add_to_cart',
        ecommerce_ga4: {
          items: [{ ...mapCartLine(cartLine), quantity }],
        },
        transactionProducts: mapTransactionProducts(cart.lines),
        subtotal: cart.cost.subtotalAmount,
        currency: cart.cost.currencyCode,
      }

      Analytics.event(ATCEvent)
    }
  )

  const decreaseCartItemToken = onDecreaseCartLineEvent(
    ({ cartLine, quantity, cart }) => {
      Analytics.event({
        ecommerce_ga4: null,
      })
      Analytics.event({
        event: 'remove_from_cart',
        ecommerce_ga4: {
          items: [{ ...mapCartLine(cartLine), quantity: quantity * -1 }],
        },
        transactionProducts: mapTransactionProducts(cart.lines),
        subtotal: cart.cost.subtotalAmount,
        currency: cart.cost.currencyCode,
      })
    }
  )

  const viewCartToken = onViewCartEvent(({ cart }) => {
    Analytics.event({
      ecommerce_ga4: null,
    })
    Analytics.event({
      event: 'view_cart',
      ecommerce_ga4: {
        items: mapCartLines(cart),
      },
      transactionProducts: mapTransactionProducts(cart.lines),
      subtotal: cart.cost.subtotalAmount,
      currency: cart.cost.currencyCode,
    })
  })

  return () => {
    removeIncreaseCartLineEvent(increaseCartItemToken)
    removeDecreaseCartLineEvent(decreaseCartItemToken)
    removeViewCartEvent(viewCartToken)
  }
}
